import { VERIFY_EMAIL_RESPONSE_TYPE } from '@/models/entities/api/authorization-resource/verify-email-response-type';
import { validateStringProperty } from '@/models/entities/type-utils';
import VerifyEmailResponse from '@/models/entities/api/authorization-resource/verify-email-response';

export default class VerifyEmailResponseEmail extends VerifyEmailResponse {
  emailResponseType: typeof VERIFY_EMAIL_RESPONSE_TYPE.VERIFICATION_EMAIL_SENT;

  key: string;

  constructor(source: unknown) {
    super(source);
    if (this.parsedEmailResponseType !== VERIFY_EMAIL_RESPONSE_TYPE.VERIFICATION_EMAIL_SENT) {
      throw new Error('Improper (unvalidated) use of constructor.');
    }
    this.emailResponseType = this.parsedEmailResponseType;
    this.key = validateStringProperty(source, 'key', false);
  }
}
